import { DateTimeUtil } from "igniteui-webcomponents/components/date-time-input/date-util";
import { AuditPointOfContact } from "./auditPointofcontact.model";
import { AuditProjectArtifactModel } from "./auditProjectArtifact.model";

export class AuditModel {
    constructor() {
        this.isActive = true;
        this.generalcategoryDTO = new GeneralCategoryResDTO();
        this.pointofContactsDTO = [];
        this.projectArtifactsDTO = new AuditProjectArtifactModel();
        this.CategoryIdsubauditorDTO = [];
    }
    id: number;
    
    auditId: number;
    auditorId: number;
    generalcategoryDTO = new GeneralCategoryResDTO();
    pointofContactsDTO : Array<AuditPointOfContact> = [];
    projectArtifactsDTO  = new AuditProjectArtifactModel();
    
    CategoryIdsubauditorDTO: Array<CategoryIdsubauditorDTO> = [];
    isActive: boolean;

    projectId: number;
    statusId: number;
    TechStackIds: number[];
    managerId: number;
    deliveryManagerId: number;
    portfoliomanagerId : number;
    expectedAuditStartDate: Date;
    expectedAuditEndDate : DateTimeUtil;

    createdBy:number;
    createdDate:Date;
    modifiedDate:Date;
    modifiedBy:number;

}

export class CategoryIdsubauditorDTO {
    constructor() {
    }
    CategoryId : number;
    SubAuditorID:number;
}

export class GeneralCategoryResDTO{
    auditId: number;
    teamSize: number;
    timeForLastAudit: string;
    auditInitiation: string;
    scopeOfAudit: string;
    developmentMethodology: number;
    deliveryModel: string;
    sourceAndVersionControlStrategy: string;
    codeReviewFrequencyAndProcess: string;
    commitCheckInPolicy: string;
    codeStandardsAndGuideLines: string;
    earlierAuditReportReviewAndApprovedBy: number;
    recordTeamTypicalDevelopmentAndDeliveryActivities: string;
    auditFrequency:number;
    projectDocumentationPath: string;
}